import { useMemo } from 'react';
import { isDefined } from '../../lib/util';
import {
  type CoaPortCostsQuery,
  type CoaPortCostsQueryVariables,
  CoaPortCostsDocument,
  useCoaPortCostsQuery,
} from '../../graphql';
import { mapGroupBy3 } from '@seaber/common/lib/collections';
import type { ApolloClient } from '@apollo/client';

const parsePortCostsByCoa = (portCostsByCoa: CoaPortCostsQuery | undefined) => {
  const filterPortCostsByCoa =
    portCostsByCoa?.allCoaContractPortCosts?.nodes.filter(isDefined) ?? [];

  if (!filterPortCostsByCoa) return undefined;

  const portCostByCoaMap = mapGroupBy3(
    filterPortCostsByCoa,
    (pc) => pc.coaContractId,
    (pc) => pc.shipId || (pc.vesselTypeId && pc.vesselTypeId * -1),
    (pc) => pc.locationId,
  );

  return portCostByCoaMap;
};

export async function getPortCostsByCoa(client: ApolloClient<unknown>) {
  const { data: portCostsByCoa } = await client.query<
    CoaPortCostsQuery,
    CoaPortCostsQueryVariables
  >({
    query: CoaPortCostsDocument,
  });
  return parsePortCostsByCoa(portCostsByCoa);
}

export type PortCostByCoaMaps = ReturnType<typeof usePortCostsCoa>;

export function usePortCostsCoa(shouldSkip = false) {
  const { data: portCostsByCoa } = useCoaPortCostsQuery({
    skip: shouldSkip,
  });

  return useMemo(() => parsePortCostsByCoa(portCostsByCoa), [portCostsByCoa]);
}
